const PUBLIC_SITE_ORIGIN = (
    process.env.REACT_APP_PUBLIC_SITE_URL || "https://display-promo.ru"
).replace(/\/+$/, "");

export function absolutizePublicUrl(pathOrUrl) {
    if (!pathOrUrl) {
        return "";
    }

    if (/^https?:\/\//i.test(pathOrUrl)) {
        return pathOrUrl;
    }

    return new URL(pathOrUrl, `${PUBLIC_SITE_ORIGIN}/`).toString();
}

export function buildAdvertiserPublicUrl(hash, fallbackUrl = "") {
    if (hash) {
        return absolutizePublicUrl(`/advertisers/${hash}`);
    }

    if (fallbackUrl) {
        try {
            const parsed = new URL(fallbackUrl);
            return absolutizePublicUrl(parsed.pathname);
        } catch {
            return absolutizePublicUrl(fallbackUrl);
        }
    }

    return "";
}

export async function copyTextToClipboard(text) {
    if (!text) {
        throw new Error("Пустая ссылка");
    }

    if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";

    document.body.appendChild(textarea);
    textarea.select();

    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);

    if (!copied) {
        throw new Error("Не удалось скопировать ссылку");
    }
}
